export default __webpack_public_path__ + "static/media/White.7fdb237d.png";